import React, { useEffect, useState } from "react";
import { FaBoxes, FaExclamationTriangle, FaTimesCircle, FaCoins } from "react-icons/fa";
import KPICard from "../Analytics/KPICard";
import * as inventoryService from "../../services/inventoryService";
import { getVendorCurrency } from "../../utils/currency";

// Reuses KPICard as-is (no booking-domain coupling, unlike Table.jsx) rather
// than building a near-duplicate stat tile. No "previous period" comparison
// exists for these counts, so DeltaBadge/KPICard simply renders with no delta
// when `previous` is omitted (see DeltaBadge.jsx's `previous == null` guard).
function InventoryDashboardWidget() {
  const [widget, setWidget] = useState(null);

  useEffect(() => {
    inventoryService.getDashboardWidget().then((res) => setWidget(res?.data || null));
  }, []);

  if (!widget) return null;

  return (
    <div className="d-flex flex-wrap gap-3 mb-4">
      <KPICard
        icon={FaBoxes}
        label="Total Items"
        current={widget.total_items}
        iconColor="#2563EB"
        iconBackground="#EFF6FF"
        style={{ flex: "1 1 200px" }}
      />
      <KPICard
        icon={FaExclamationTriangle}
        label="Low Stock"
        current={widget.low_stock_count}
        iconColor="#D97706"
        iconBackground="#FEF3C7"
        style={{ flex: "1 1 200px" }}
      />
      <KPICard
        icon={FaTimesCircle}
        label="Out of Stock"
        current={widget.out_of_stock_count}
        iconColor="#DC2626"
        iconBackground="#FEE2E2"
        style={{ flex: "1 1 200px" }}
      />
      <KPICard
        icon={FaCoins}
        label="Stock Value (at cost)"
        current={widget.total_stock_value}
        format="currency"
        currency={getVendorCurrency()}
        iconColor="#059669"
        iconBackground="#D1FAE5"
        style={{ flex: "1 1 200px" }}
      />
    </div>
  );
}

export default InventoryDashboardWidget;
